import { Link as RouterLink } from '@tanstack/react-router'
import { Badge, Button, Flex, Link, Text } from '@radix-ui/themes'
import { PlusIcon } from '@radix-ui/react-icons'
import { SectionCard } from '~/components/SectionCard'
import { stageColor, stageLabel } from '~/features/installations/constants'
import { computeStage } from '~/features/installations/service'
import { CreateInstallationDialog } from './CreateInstallationDialog'
import type { StationDetail, StationSectionProps } from '../types'

interface InstallationRowProps {
  installation: StationDetail['installations'][number]
}

const InstallationRow = ({ installation }: InstallationRowProps) => {
  const stage = computeStage(installation)

  return (
    <Flex align="center" justify="between" gap="3">
      <Flex align="center" gap="3">
        <Link asChild size="2" className="font-mono">
          <RouterLink
            to="/installations/$installationId"
            params={{ installationId: String(installation.installation_id) }}
          >
            #{installation.installation_id}
          </RouterLink>
        </Link>
        <Badge color={stageColor[stage]} variant="soft" size="1">
          {stageLabel[stage]}
        </Badge>
      </Flex>
      <Text size="2" color="gray">
        {installation.installation_date ?? '—'}
      </Text>
    </Flex>
  )
}

export const StationInstallationsCard = ({ station }: StationSectionProps) => (
  <SectionCard title="Installations">
    <Flex direction="column" align="start" gap="3">
      {station.installations.length === 0 ? (
        <Text size="2" color="gray">
          No installation linked — this station was created directly in the app.
        </Text>
      ) : (
        <Flex direction="column" gap="2" width="100%">
          {station.installations.map((installation) => (
            <InstallationRow key={installation.installation_id} installation={installation} />
          ))}
        </Flex>
      )}
      {station.measurement_type === 'water_volume' ? (
        <CreateInstallationDialog station={station}>
          <Button variant="soft" size="1">
            <PlusIcon />
            Create installation
          </Button>
        </CreateInstallationDialog>
      ) : null}
    </Flex>
  </SectionCard>
)
